import React from 'react'
import { Table, Badge, Anchor, Menu, ActionIcon } from '@mantine/core'
import { IconPhoto, IconFiles, IconTrash, IconDotsVertical } from '@tabler/icons-react'
import dayjs from 'dayjs'

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={200} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const OrderDocumentTable = ({label, data, actionMethod}) => {

  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>{val.attributes.name}</Table.Td>
        <Table.Td>
          <Badge variant="light" tt='capitalize' w={100} fw={500} color='black' leftSection={val.attributes.label === 'image' ? <IconPhoto size={12} /> : <IconFiles size={12} /> }>{val.attributes.label}</Badge>
        </Table.Td>
        <Table.Td>
          <Anchor fz={12} underline="hover" c='blue' fw='500' href={val.attributes.url} target='_blank'>Download Attachment</Anchor>
        </Table.Td>
        <Table.Td>{dayjs(val.attributes.created_at).format('DD-MM-YYYY HH:mm A')}</Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} detail={val} /></Table.Td>
      </Table.Tr>
    )
  })


  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default OrderDocumentTable